import { TenantSubscription } from '../../entities/tenant/tenant';
import { BaseSecurityModule } from '../base.security.module';
import { SecurityModuleName, SecurityRight } from '../security.module';

export enum VariationSecurityRight {
    CanAccess = 16000,
    Manage = 16001,
}

export class VariationSecurityModule extends BaseSecurityModule<VariationSecurityRight> {

    constructor() {
        super(
            SecurityModuleName.Variations,
            [
                { _id: VariationSecurityRight.CanAccess, name: 'Access', basic: true },
                { _id: VariationSecurityRight.Manage, name: 'Manage', basic: true },
            ] as SecurityRight<VariationSecurityRight>[]
        );

        this.plan = TenantSubscription.Custom;
    }


}
